import { useMemo } from "react";
import { useSelector } from "react-redux";
import { ApplicationState } from "@/store";

export const useManageLossFilterState = () => {
  const selectFilter = (state: ApplicationState) => state.manageLossFilter;

  const filterState = useSelector(selectFilter);

  return useMemo(() => filterState, [filterState]);
};

export const useFilterState = useManageLossFilterState;
